import { z } from "zod";

export const AUTH_EMAIL_ADDRESS_MAX_LENGTH = 320;

export const AUTH_EMAIL_ERROR_MAX_LENGTH = 2000;

export const authEmailEventType = z.enum(["auth_signup", "auth_signup_resend", "auth_password_reset"]);
export type AuthEmailEventType = z.infer<typeof authEmailEventType>;

export const authEmailEventStatus = z.enum(["requested", "failed"]);
export type AuthEmailEventStatus = z.infer<typeof authEmailEventStatus>;

export const authEmailEventRequest = z
  .object({
    eventType: authEmailEventType,
    recipientEmail: z.string().trim().max(AUTH_EMAIL_ADDRESS_MAX_LENGTH).email(),
    status: authEmailEventStatus.default("requested"),
    payload: z.record(z.string(), z.unknown()).optional(),
    errorMessage: z.string().max(AUTH_EMAIL_ERROR_MAX_LENGTH).optional(),
  })
  .strict();
export type AuthEmailEventRequest = z.input<typeof authEmailEventRequest>;
export type AuthEmailEvent = z.output<typeof authEmailEventRequest>;

export const authEmailEventRecorded = z.object({ recorded: z.literal(true) });
export type AuthEmailEventRecorded = z.infer<typeof authEmailEventRecorded>;
